import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import { IReduxState } from '../../store';
import { IEnseignantItem } from '../../store/focusEcoleSlice';

export interface IStatistiqueProps {
    localDatasFiltered: IEnseignantItem[];
}


export default function Statistique(props: IStatistiqueProps) {
    const { localDatasFiltered } = props
    const { enseignants, etabsAppelNote } = useSelector((state: IReduxState) => state.focusEcole);



    return (
        <Box sx={{ display: "flex", gap: 4, background: "#EEEEEE", padding: 0.5, borderRadius: 1, justifyContent: "center" }}>
            <Typography
                color="text.secondary"
                style={{ fontSize: "10px" }}
            >
                <span style={{ color: "yellowgreen", fontWeight: "bold", fontSize: 12 }}>{`${etabsAppelNote.length}`}</span>
                <br />
                Etablissement
            </Typography>
            <Typography
                color="text.secondary"
                style={{ fontSize: "10px" }}
            >
                <span style={{ color: "error", fontWeight: "bold", fontSize: 12 }}>{enseignants?.length}</span>
                <br />
                Nomber total
            </Typography>
            <Typography
                color="text.secondary"
                style={{ fontSize: "10px" }}
            >
                <span style={{ color: "#1976D2", fontWeight: "bold", fontSize: 12 }}>{`${localDatasFiltered?.length}`}</span>
                <br />
                Selectionnés
            </Typography>
        </Box>
    );
}
